<template>
  <div class="w-full h-full">
    <div class="flex">
      <el-select
        v-model="searchData.areaId"
        :popper-append-to-body="false"
        popper-class="visualization-select-popper"
        class="mr-10px flex-1"
        clearable
        filterable
        @change="handleSearch()"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="item in areaList"
          :key="item.id"
        ></el-option>
      </el-select>
      <el-input
        placeholder="摄像头名称"
        v-model="searchData.keyword"
        size="small"
        clearable
        @keypress.enter.native="handleSearch()"
        class="icon-search__input mb-10px flex-1"
      >
        <i
          slot="append"
          class="el-icon-search cursor-pointer icon-search__input"
          @click="handleSearch()"
        ></i>
      </el-input>
    </div>
    <el-table
      :data="tableData"
      highlight-current-row
      :height="tableHeight"
      ref="tableRef"
      v-loading="tableLoading"
    >
      <el-table-column label="序号" type="index" width="50px"></el-table-column>
      <el-table-column label="摄像头名称" show-overflow-tooltip prop="name"></el-table-column>
      <el-table-column label="所属区域" show-overflow-tooltip prop="areaName"></el-table-column>
      <el-table-column label="操作" width="50px" show-overflow-tooltip prop="isTicketExtension">
        <template slot-scope="scope">
          <i class="iconfont text-16px icon-bg-display" @click="viewScamera(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="currentChange"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      layout="prev, pager, next"
      :total="total"
      class="text-center"
    ></el-pagination>
  </div>
</template>

<script>
import { EquipmentMonitoringApi } from '@wiz-api/emergency-management'
import { AreaApi } from '@wiz-api/area-management'
import { instance as cloudRender } from 'wiz-cloud-render'
import bus from './bus'

const equipmentMonitoringApi = new EquipmentMonitoringApi()
const areaApi = new AreaApi()
export default {
  data() {
    return {
      typeList: [],
      tableData: [],
      tableLoading: true,
      pageSize: 15,
      pageNo: 1,
      searchData: {
        keyword: '',
        areaId: '',
      },
      total: 0,
      areaList: [],

      areaId: '',
      sceneId: '',
    }
  },
  async created() {
    await this.getAreaList()
    this.findList()
    window.addEventListener('sendAreaId', this.areaIdChange)
  },
  methods: {
    areaIdChange(e) {
      this.areaId = e.detail.areaId
      this.findList()
    },
    // 获取风险区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        modelId: this.sceneId,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && res) {
        this.areaList = res.items
      }
    },
    // 打开摄像头
    viewScamera(data) {
      if (data.isPoint) {
        cloudRender.Engine.player.Native.Camera.moveToPos(JSON.parse(data.threeDPosition), 0, 10, 2)
      }
      bus.$emit('translate', { row: data, type: 'camera' })
    },
    async findList() {
      this.tableLoading = false
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...this.searchData,
      }
      data.areaId = this.searchData.areaId || this.areaId
      if (!data.areaId) {
        data.areaIds = this.areaList.map((item) => {
          return item.id
        })
      }
      this.loading = true
      const [err, res] = await equipmentMonitoringApi.pagedListQuery(data)
      this.tableLoading = false
      if (err) return
      this.tableData = res.items
      this.total = res.totalCount
    },
    // 获取物资类型
    async getType() {
      const params = {
        skipCount: 0,
        maxResultCount: 99,
      }
      const [err, data] = await suppliesTypeApi.getList(params)
      if (!err) {
        this.typeList = data.items
      }
    },
    handleSearch() {
      this.pageNo = 1
      this.findList()
    },
    // 页数改变
    currentChange(SkipCount) {
      this.SkipCount = SkipCount
      this.findList()
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 80px)'
    },
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
  },
  watch: {
    transferProps: {
      handler(data) {
        this.areaId = data.areaId
        this.sceneId = data.sceneId
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}

::v-deep .el-pagination.is-background.el-pagination--small .el-pager li {
  padding: 0 4px;
  margin: 0 5px;
  min-width: 24px;
}
</style>
